<div class="grid-container">
  <section class="margin-top">
    <h2>Builder</h2>
    <div class="grid-x minor-margin-bottom">
      <div class="cell small-12 medium-6">
        <label class="inline input-line-height" for="collectionName"><b>Collection name:</b> <i>(advanced, determines where entities are stored in database)</i></label>
      </div>
      <div class="cell small-12 medium-6">
        <input type="text" class="no-margin-bottom" id="collectionName" [(ngModel)]="entity.collectionName" />
      </div>
      <div class="cell small-12 medium-6">
        <label class="inline input-line-height" for="partitionKey"><b>Partition Key Field:</b> <i>(advanced, determines where entities are stored in database)</i></label>
      </div>
      <div class="cell small-12 medium-6">
        <input type="text" class="no-margin-bottom" id="partitionKey" [(ngModel)]="entity.partitionKey" />
      </div>
      <div class="cell small-12 medium-6">
        <label class="inline input-line-height" for="partitionKeyValue"><b>Partition Key Value:</b> <i>(advanced, determines where entities are stored in database)</i></label>
      </div>
      <div class="cell small-12 medium-6">
        <input type="text" class="no-margin-bottom" id="partitionKeyValue" [(ngModel)]="entity.partitionKeyValue" />
      </div>
      <div class="cell small-12 medium-6">
        <label class="inline input-line-height" for="adminCorrectionGroupId"><b>Admin Data Correction Review Group:</b> <i>(advanced, determines which group reviews admin data correction submissions for this entity)</i></label>
      </div>
      <div class="cell small-12 medium-6">
        <select id="adminCorrectionGroupId" [(ngModel)]="entity.adminCorrectionGroupId">
          <option [value]=""></option>
          @for (group of groups; track group) {
            <option [value]="group.id">
              {{ group.displayName }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="white-bg padding-all border-one-pixel-solid-gray">
      <div class="grid-x minor-margin-bottom">
        <div class="cell auto">
          {{entity.schemaObject.title}}: <b>{{entity.schemaObject.type}}</b>
        </div>
        <div class="cell shrink">
          <button (click)="add()" attr.aria-label="Add New Entity Builder Schema"><svg-icon icon="icon-plus" aria-hidden="true" class="small dark-gray float-right cursor-pointer"></svg-icon></button>
          <button (click)="edit()" attr.aria-label="Edit '{{entity.schemaObject.title}}'"><svg-icon icon="icon-pencil" aria-hidden="true" class="small dark-gray float-right cursor-pointer"></svg-icon></button>
        </div>
      </div>
      <ng-template ebComponentHost></ng-template>
    </div>
  </section>

  <section class="margin-top-large margin-bottom-large">
    <h2>Schema</h2>
    <div class="white-bg border-one-pixel-solid-gray">
      <textarea disabled="disabled">{{entity.schemaObject | json}}</textarea>
    </div>
  </section>
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
